import { render, staticRenderFns } from "./deleteStoreMsg.vue?vue&type=template&id=60310683"
import script from "./deleteStoreMsg.vue?vue&type=script&lang=js"
export * from "./deleteStoreMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports